import axios from 'axios';

const api = axios.create({
  baseURL: '/api/lostark/party',
  headers: { 'Content-Type': 'application/json' },
});

export default api;
